"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Bookingkit Api v4
 * Specification of Bookingkit Api v4
 *
 * The version of the OpenAPI document: 0.25.2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserSupplierScopesEnum = void 0;
exports.UserSupplierScopesEnum = {
    Booking: 'booking',
    Event: 'event',
    Reach: 'reach',
    SellMarketing: 'sell_marketing',
    Statistic: 'statistic',
    Setting: 'setting',
    Users: 'users',
    Accounting: 'accounting',
    BookingWrite: 'booking_write',
    EventWrite: 'event_write',
    ReachWrite: 'reach_write',
    SellMarketingWrite: 'sell_marketing_write',
    StatisticWrite: 'statistic_write',
    SettingWrite: 'setting_write',
    UsersWrite: 'users_write',
    AccountingWrite: 'accounting_write',
    Marketing: 'marketing',
    MarketingWrite: 'marketing_write',
    SellCheckoutConfiguration: 'sell_checkout_configuration',
    SellCheckoutConfigurationWrite: 'sell_checkout_configuration_write',
    StatisticsExport: 'statistics_export',
    StatisticsExportWrite: 'statistics_export_write',
    Customization: 'customization',
    CustomizationWrite: 'customization_write',
    OrderCreateAndEdit: 'order_create_and_edit',
    OrderEditAfterService: 'order_edit_after_service',
    OrderEditRefundAmount: 'order_edit_refund_amount'
};
